import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef } from 'react';
import { css } from 'styled-components';
import { entitiesFilter } from '../../../../../utils/helpers/common';
import { NewSearchEmpty } from '../../../../NewSearch/NewSearchCities/NewSearchEmpty';
import { NewRadioButton } from '../../../../NewRadioButton';
import useScreenSize from '../../../../../hooks/useScreenSize';
import { City, Location } from '../../../../../graphql/types';

interface SelectListProps {
  searchString: string;
  showAllList: boolean;
  currentValue: string;
  data: Partial<Location | City>[];
  onChange: (e?: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  containerCypress: string;
  radioCypress: string;
  radioName: string;
}

const emptyTextStyles = css`
  color: ${({ theme: { colors } }) => colors.text.primary};
  font-size: 20px;
  font-weight: 500;
`;

export const SelectList: React.FC<SelectListProps> = ({
  searchString,
  error,
  showAllList,
  currentValue,
  data,
  onChange,
  containerCypress,
  radioCypress,
  radioName
}) => {
  const { t } = useTranslation();
  const { isSmall } = useScreenSize();
  const selectedItemRef = useRef<HTMLLabelElement | null>(null);

  useEffect(() => {
    if (selectedItemRef.current && !isSmall) {
      selectedItemRef.current.scrollIntoView({
        block: 'center',
        inline: 'start',
        behavior: 'smooth'
      });
    }
  }, [isSmall, selectedItemRef.current]);

  const allItemsList = entitiesFilter(
    data,
    showAllList ? '' : searchString
  ).map(item => {
    const isSelected = currentValue === item.id;

    return (
      <NewRadioButton
        key={item.id}
        data={item}
        onChangeHandler={onChange}
        currentValue={currentValue}
        name={radioName}
        cypress={radioCypress}
        markerPosition="right"
        ref={isSelected ? selectedItemRef : null}
      />
    );
  });

  return (
    <>
      {!!allItemsList.length && !error && (
        <div data-cy={containerCypress}>{allItemsList}</div>
      )}

      {!allItemsList.length && searchString && (
        <NewSearchEmpty
          emptyText={t('search.nothing_found')}
          width={isSmall ? undefined : 280}
          height={isSmall ? undefined : 210}
          emptyTextStyles={emptyTextStyles}
        />
      )}
    </>
  );
};
